$( function() {
	$('.gallery.current-images').Chocolat({
		imageSelector: '.img-wrapper'
	});
});